import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import AgreementsListElement from '@/features/trustees/components/agreements/AgreementsListElement';
import { cn } from '@/lib/utils';

const testData: { id: string; type: 'purchase' | 'management' }[] = [
	{ id: 'AG-2025-001', type: 'purchase' },
	{ id: 'AG-2025-002', type: 'management' },
];

type Props = {
	isMobile?: boolean;
};

const AgreementsList: FC<Props> = ({ isMobile }) => {
	const { t } = useTranslation();

	return (
		<div className='flex flex-col gap-4 select-none'>
			<div className='flex items-center justify-between gap-2'>
				<h3 className={cn(isMobile && 'text-base')}>
					{t('main.agreements.title')}
				</h3>
			</div>
			<div className='flex flex-col gap-2'>
				{testData.map((agr, index) => (
					<AgreementsListElement
						key={index}
						{...agr}
						isMobile={isMobile}
					/>
				))}
			</div>
		</div>
	);
};

export default AgreementsList;
